import React, { useCallback, useState, useEffect } from 'react'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import InputError from '../../../components/InputError/InputError'
import NeoButton from '../../../components/NeoButton/NeoButton'
import {
  REQUESTS_KEYS,
  SIDENAV_KEYS,
  VALIDATION_MESSAGES,
} from '../../../utils/translation-constants'
import AccountDisplay from '../../../components/account-display/account-display'
import { carouselCurrentItemSelector, remarksSelector } from '../../../selectors'
import { useSelector } from 'react-redux'
import Loading from 'custom/assets/loaders/Loading'
import { Formik, Field, Form } from 'formik'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import NeoInput from '../../../components/NeoInput/NeoInput'
import DashboardService from '../../../services/dashboard.service'
import GimacService from '../../../services/gimac.service'
import { GimacTransferSchema } from '../../../schemas/gimac'
import NeoOTP from '../../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../../components/FormComponents/NeoSuccess'

export default function GimacTransfer() {
  const { t } = useTranslation()
  const history = useHistory()
  const [stage, setStage] = useState(0)
  const [remarksList, setRemarksList] = useState([])
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const [loading, setLoading] = useState(false)
  const [walletNo, setWalletNo] = useState([])
  const [walletDuplicate, setWalletDuplicate] = useState([])
  const [formValues, setFormValues] = useState({})
  const [payDuplicate, setPayDuplicate] = useState([])
  const [otp, setOtp] = useState('')
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [message, setMessage] = useState('')
  const [formData, setFormData] = useState([])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderform()
      case 2:
        return renderConfirm()
      case 3:
        return (
          <NeoOTP otp={otp} setOTP={setOtp} onSubmit={gimacTransferConfirm} loading={loading} />
        )
      case 4:
        return <NeoSuccess message={message} linkPath='/gimac-pay' />
      default:
        return renderform()
    }
  }

  useEffect(() => {
    getRemarksList()
    getGimacProviderList()
  }, [])

  const getRemarksList = useCallback(async () => {
    try {
      const response = await DashboardService.getRemarksCategory()
      if (response.status === 200) {
        setLoading(false)
        setRemarksList(response.data.remarks)
      }
    } catch (err) {}
  }, [])

  const getGimacProviderList = useCallback(async () => {
    try {
      setLoading(true)
      const response = await GimacService.getGimacProviderList()
      setWalletNo(response)
      let setObj = new Set()
      let result = response.reduce((acc, item) => {
        if (!setObj.has(item.operationType)) {
          setObj.add(item.operationType, item)
          acc.push(item)
        }
        return acc
      }, [])
      setWalletDuplicate(result)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const handlemerchantPayment = (e) => {
    let result = walletNo.filter((item) => item.operationType === e)
    setPayDuplicate(result)
  }

  const gimacTransferVerify = useCallback(
    async (values) => {
      try {
        setLoading(false)
        setFormValues(values)
        const data = walletNo.find(
          (item) => item.operationName === values.pay && item.operationType === values.wallet,
        )
        setFormData(data)
        let reqParam = {
          amount: Number(parseFloat(values.amount.replaceAll(',', '')).toFixed(2)),
          srcAccount: currentAccountDetail.accountNo,
          srcAccBranch: currentAccountDetail.brnCode,
          srcAccCcy: currentAccountDetail.currency,
          destAccount: values.mobileNo,
          // category: data.intent,
          category: "mobile_transfer",
          toMember: data.code,
          remarks: values.remarks != 'Custom' ? values.remarks : values.customRemarks,
          txnCurrency: currentAccountDetail.currency,
        }
        const response = await GimacService.gimacWalletVerify(reqParam)
        setOtpEnabled(response['otpEnable'])
        setStage(2)
      } catch (err) {
        setLoading(false)
      }
    },
    [currentAccountDetail, walletNo],
  )

  const gimacTransferConfirm = useCallback(async () => {
    try {
      setLoading(true)
      let req = {
        amount: Number(parseFloat(formValues.amount.replaceAll(',', '')).toFixed(2)),
        srcAccount: currentAccountDetail.accountNo,
        srcAccBranch: currentAccountDetail.brnCode,
        srcAccCcy: currentAccountDetail.currency,
        destAccount: formValues.mobileNo,
        // category: formData.intent,
        category: "mobile_transfer",
        remarks: formValues.remarks != 'Custom' ? formValues.remarks : formValues.customRemarks,
        txnCurrency: currentAccountDetail.currency,
        otp: otp || '0000',
        toMember: formData.code,
      }
      const response = await GimacService.gimacWalletConfirm(req)
      if (response.status === 'SUCCESS') {
        setMessage(response['message'])
        setStage(4)
      }
    } catch (err) {
      setLoading(false)
      setOtp('')
    }
  }, [formData, formValues, otp, currentAccountDetail])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderform() {
    return (
      <Formik
        initialValues={{
          wallet: '',
          pay: '',
          mobileNo: '',
          amount: '',
          remarks: '',
          customRemarks: '',
        }}
        validationSchema={GimacTransferSchema}
        onSubmit={gimacTransferVerify}>
        {({ isSubmitting, errors, touched, handleChange, setFieldValue, values }) => (
          <Form>
            <div className='heading-style'>GIMAC Transfers</div>
            <AccountDisplay currentAccountDetail={currentAccountDetail} />
            <div className='d-flex row'>
              <div className='col-12'>
                <div className='form-group my-2'>
                  <NeoInput
                    tabIndex='1'
                    mode='select'
                    text={'Recipient Wallet'}
                    name='wallet'
                    onChange={(e) => {
                      handlemerchantPayment(e.target.value)
                      setFieldValue('pay', '')
                      handleChange(e)
                    }}
                    list={walletDuplicate}
                    keyValue='operationType'
                    value={values.wallet}
                    showAsterisk={true}
                  />
                  <InputError text={errors.wallet} touched={touched.wallet} />
                </div>

                <div className='form-group my-2'>
                  <NeoInput
                    tabIndex='1'
                    mode='select'
                    text={'Recipient Payment'}
                    name='pay'
                    onChange={handleChange}
                    list={payDuplicate}
                    keyValue='operationName'
                    value={values.pay}
                    showAsterisk={true}
                  />
                  <InputError text={errors.pay} touched={touched.pay} />
                </div>

                <div className='form-group my-2'>
                  <NeoInput
                    tabIndex='2'
                    text={'Recipient Wallet No.'}
                    onChange={(values) => {
                      setFieldValue('mobileNo', values.value)
                    }}
                    mode='onlyNumber'
                    name='mobileNo'
                    value={values.mobileNo}
                    showAsterisk={true}
                  />
                  <InputError text={errors.mobileNo} touched={touched.mobileNo} />
                </div>

                <div className='form-group'>
                  <NeoInput
                    tabIndex='3'
                    text={'Amount'}
                    name='amount'
                    onChange={(values) => {
                      setFieldValue('amount', values.value)
                    }}
                    mode='amount'
                    value={values.amount}
                    showAsterisk={true}
                  />
                  <InputError text={errors.amount} touched={touched.amount} />
                  <InputError
                    text={t(VALIDATION_MESSAGES.AMOUNT_VALID)}
                    touched={values.amount === '0.00' || values.amount === '.00'}
                  />
                </div>

                <div className='form-group '>
                  <NeoInput
                    tabIndex='4'
                    text={t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.REMARKS)}
                    mode='select'
                    name='remarks'
                    onChange={(e) => {
                      handleChange(e)
                    }}
                    list={remarksList}
                    keyValue={null}
                    showAsterisk={true}
                  />
                  <InputError text={errors.remarks} touched={touched.remarks} />
                </div>

                <div className='form-group'>
                  {values.remarks === 'Custom' && (
                    <>
                      <NeoInput
                        tabIndex='5'
                        text={'Custom Remarks'}
                        onChange={handleChange}
                        name='customRemarks'
                        showAsterisk={true}
                      />
                      <InputError text={errors.customRemarks} touched={touched.customRemarks} />
                    </>
                  )}
                </div>

                <div className='mt-5'>
                  {isSubmitting ? (
                    renderLoading()
                  ) : (
                    <NeoButton
                      tabIndex='6'
                      type='submit'
                      mode='newDesign'
                      text={t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_KEYS.SUBMIT)}
                    />
                  )}
                </div>
                <div className='back-cancel-btn-container'>
                  <button
                    className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                    tabIndex={'7'}
                    onClick={() => history.goBack()}>
                    {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    )
  }

  function renderConfirm() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3>Confirm Gimac Transfers</h3>
        <div>
          <h6 className='label'>Recipient Wallet</h6>
          <h6 className='value'>{formValues.wallet}</h6>
        </div>

        <div>
          <h6 className='label'>Recipient Payment</h6>
          <h6 className='value'>{formData.operationName}</h6>
        </div>

        <div>
          <h6 className='label'>Recipient Wallet No.</h6>
          <h6 className='value'>{formValues.mobileNo}</h6>
        </div>

        <div>
          <h6 className='label'>Amount</h6>
          <h6 className='value'>{formValues.amount}</h6>
        </div>

        <div>
          <h6 className='label'>Remarks</h6>
          <h6 className='value'>
            {formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks}
          </h6>
        </div>

        <div className='mt-3'>
          {loading ? (
            renderLoading()
          ) : (
            <NeoButton
              type='button'
              text={t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.CONFIRM)}
              mode={'newDesign'}
              onClick={() => (otpEnabled ? setStage(3) : gimacTransferConfirm())}
            />
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
          {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
        </div>
      </div>
    )
  }

  return (
    <LayoutWithAccountCard
      breadCumKey='GIMAC_TRANSFER'
      keyPath={'GIMAC_TRANSFER'}
      showEmptySpace={true}>
      <div className='new-design-form-style'>{renderSwitch()}</div>
    </LayoutWithAccountCard>
  )
}
